<template>
  <div class="setting-main">
    <div class="setting-container">
      <div class="setting-container-border">
        <button class="music-btn">
          音乐设置
        </button>
        <vue-slider class="vue-slider" v-model="musicVolume" :lazy="true" :drag-on-click="true" dotSize="60"
                    style="padding: 3vw 0;width: 60%;height: 1.5vw;" tooltip='none' @change="change" />
        <button class="setting-btn" @click="openWifiSetting">
          WIFI连接
        </button>
        <img src='../assets/image/settingPage/SettingExitButton.png' class="exit-button" @click="exit" />
      </div>
    </div>
  </div>
</template>

<script>

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  name: 'SettingPage',
  components: {
    VueSlider
  },
  data() {
    return {
      musicVolume: 100,
    };
  },
  methods: {
    openWifiSetting: function () {
      try {
        // eslint-disable-next-line no-undef
        test.postMessage("123123123");
        console.log("sent");
      } catch (e) {
        console.log(e);
      }
    },
    change: function () {
      console.log(this.musicVolume);
    },
    exit: function () {
      this.$router.go(-1);
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped>
.setting-main {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../assets/image/NormalBg.png");
}

.setting-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.setting-container-border {
  background-image: url("../assets/image/settingPage/SettingPageCenterBorderBg.png");
  background-size: 100% 100%;
  border: none;
  height: 57vw;
  width: 60vw;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin: 4.2vw 0;
  position: absolute;
}

.setting-btn {
  height: 11vw;
  width: 29vw;
  font-size: 5.5vw;
  background-image: url("../assets/image/settingPage/SettingButtonBg.png");
  background-size: 100% 100%;
  border: none;
  color: white;
  font-family: "PingFang", serif;
  background-color: transparent;
  margin: 0 0 8.5vw 0;
}

.music-btn {
  height: 11vw;
  width: 29vw;
  font-size: 5.5vw;
  background-image: url("../assets/image/settingPage/SettingButtonBg.png");
  background-size: 100% 100%;
  border: none;
  color: white;
  font-family: "PingFang", serif;
  background-color: transparent;
  margin: 8.5vw 0 0 0;
}

.setting-btn:active {
  transform: translateY(2px);
  background-color: transparent;
}

.exit-button {
  position: absolute;
  top: -4.2vw;
  right: -4.2vw;
  width: 15vw;
  height: 15vw;
}
</style>
